import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {EvkCreateServiceBase, EvkHttpService, EvkRequestType, MessageCrudService} from '@evomatik/evk-common';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MotivoRechazoCreateService extends EvkCreateServiceBase<any> {

    public doneSave: () => void;

    constructor(
        public http: EvkHttpService,
        public snackBar: MatSnackBar,
        public messageCrudService: MessageCrudService,
    ) {
        super(http);
    }

    get api(): string {
        return '/seaged-diligencias-service/diligencia/rechazar-autorizacion';
    }

    evkOnBeforeSave(data: any): Observable<any> {
        const observable = new Observable<any>(observer => {
            data.createdBy = localStorage.getItem('username');
            data.updatedBy = localStorage.getItem('username');
            data['motivoEstado'] = data.observaciones;
            observer.next(data);
        });
        return observable;
    }

    evkOnDoneSave(response: any): void {
        this.doneSave();
    }

    evkOnErrorSave(error: any): void {
        this.messageCrudService.snackbarMessage(error);
    }

    public save(data: any): Observable<any> {
        const request: EvkRequestType<any> = {
            id: '',
            data: data,
        };
        return this.http.post<any>(this.api, request);
    }
}
